import i18n from 'i18n';
import { SHOP_MAP } from './shop';
import LOCALS from 'commons/locals';

const RAW_ORDER_CREATE_SOURCE_MAP = {
  WEBSITE: 0,
  GINZA: SHOP_MAP.GINZA,
  HONGKONG: SHOP_MAP.HONGKONG,
  SINGAPORE: SHOP_MAP.SINGAPORE,
  SNS: 4, // 这个店铺实际上不存在，历史遗留原因；多笔支付功能上线之后，理论上就不会有 SNS 的订单
  WHATSAPP: 5,
  INSTAGRAM: 6,
  LINE: 7,
  WECHAT: 8,
  OTHER: 9,
  APP: 10,
  SHANG_HAI: SHOP_MAP.SHANG_HAI,
  UMEDA: SHOP_MAP.UMEDA,
  SINGAPORE_ASU_GST: SHOP_MAP.SINGAPORE_ASU_GST,
  SINGAPORE_GX: SHOP_MAP.SINGAPORE_GX,
  DUBAI: SHOP_MAP.DUBAI,
  FRANCE: SHOP_MAP.FRANCE,
  NEW_YORK: SHOP_MAP.NEW_YORK,
} as const;

type OrderCreateSource =
  (typeof RAW_ORDER_CREATE_SOURCE_MAP)[keyof typeof RAW_ORDER_CREATE_SOURCE_MAP];

const isValidOrderCreateSource = (
  createSource: number,
): createSource is OrderCreateSource => {
  return Object.values(RAW_ORDER_CREATE_SOURCE_MAP).includes(
    createSource as OrderCreateSource,
  );
};

export const ORDER_CREATE_SOURCE_MAP = new Proxy(RAW_ORDER_CREATE_SOURCE_MAP, {
  ownKeys() {
    throw new Error(
      '❌ 禁止遍历 ORDER_CREATE_SOURCE_MAP！请直接通过属性精准获取值，如 ORDER_CREATE_SOURCE_MAP.WEBSITE',
    );
  },
});

const RAW_ORDER_CREATE_SOURCE_CONFIG_MAP: Record<
  OrderCreateSource,
  { label: string }
> = {
  [RAW_ORDER_CREATE_SOURCE_MAP.WEBSITE]: {
    label: i18n.t(LOCALS.website),
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.GINZA]: {
    label: i18n.t(LOCALS.ginza_shop),
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.HONGKONG]: {
    label: i18n.t(LOCALS.hongkong_shop),
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.SINGAPORE]: {
    label: i18n.t(LOCALS.singapore_shop),
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.SINGAPORE_ASU_GST]: {
    label: i18n.t(LOCALS.singapore_shop_asu_gst),
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.SINGAPORE_GX]: {
    label: i18n.t(LOCALS.kkIwEnEVml),
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.UMEDA]: {
    label: i18n.t(LOCALS.umeda_store),
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.SHANG_HAI]: {
    label: i18n.t(LOCALS.shanghai_store),
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.DUBAI]: {
    label: i18n.t(LOCALS.dubai_store),
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.FRANCE]: {
    label: i18n.t(LOCALS.france_store),
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.NEW_YORK]: {
    label: i18n.t(LOCALS.new_york_store),
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.SNS]: {
    label: 'SNS',
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.WHATSAPP]: {
    label: 'WhatsApp',
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.INSTAGRAM]: {
    label: 'Instagram',
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.LINE]: {
    label: 'LINE',
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.WECHAT]: {
    label: 'WeChat',
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.OTHER]: {
    label: 'Other',
  },
  [RAW_ORDER_CREATE_SOURCE_MAP.APP]: {
    label: 'APP',
  },
};

const ORDER_CREATE_SOURCE_CONFIG_MAP = new Proxy(
  RAW_ORDER_CREATE_SOURCE_CONFIG_MAP,
  {
    ownKeys() {
      throw new Error(
        '❌ 禁止遍历 ORDER_CREATE_SOURCE_CONFIG_MAP！请直接通过属性精准获取值，如 ORDER_CREATE_SOURCE_CONFIG_MAP.WEBSITE',
      );
    },
  },
);

export const getOrderCreateSourceConfig = (createSource: number) => {
  if (!isValidOrderCreateSource(createSource)) {
    throw new Error(`Invalid order createSource: ${createSource}`);
  }

  return ORDER_CREATE_SOURCE_CONFIG_MAP[createSource];
};

export const ORDER_CREATED_FROM_OPTION_LIST = Object.values(
  RAW_ORDER_CREATE_SOURCE_MAP,
).map((createSource) => {
  return {
    value: createSource,
    label: getOrderCreateSourceConfig(createSource).label,
  };
});
